const PROJECT_BOARD_EVENTS = Object.freeze({
  NOTIFICATION: 'projectBoardNotification',
});

export default PROJECT_BOARD_EVENTS;
